import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  FormGroup,
  FormLabel,
  Alert
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { Link } from "react-router-dom"; 
import * as fb from '../../firebase';
import {addAdminLog} from "../../components/Helper";

class EditTrengoKey extends Component {

  constructor(props){
    super(props);
    this.state = {
      id:"",
      key:"",
      value:"",
      data:[],
      dataList:[],
      disabled : false,
      error:"",
      errors:{}
    }
  }

  onChangeHandler = (event) => {
    const {name, value} = event.currentTarget;
    if(name === 'value') {
      this.setState({
        value:value
      });
    }
  };

  componentDidMount = async () => {
    const  url = window.location.href;
    const key = url.substring(url.lastIndexOf('/') + 1);
    const metadata = await fb.metaCollection.doc('trengo_settings').get();
    this.setState({
      key:key,
      value:metadata.data()[key],
      data:metadata.data(),
      dataList:Object.keys(metadata.data()),
      isLoading:false
    });
  
  }

  handleValidation = () => {
    let {key, value} = this.state;
    let errors = {};
    let formIsValid = true;

    //Title
    if(!key){
      formIsValid = false;
      errors["key"] = "Key is required";
    }

    //Description
    if(!value){
      formIsValid = false;
      errors["value"] = "Value is required";
    }
    this.setState({errors: errors});
    return formIsValid;
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    this._isMounted = true;
    this.setState({disabled: true});
    if(this.handleValidation(this.state.errors)){
      await fb.metaCollection.doc('trengo_settings').update({
        [this.state.key]:this.state.value
      }).then(snapShot => {
        addAdminLog('meta_changed',
          `Changed the meta ${this.state.key} at the trengo_settings`)
        this.props.history.push('/admin/meta')
      }).catch(err=> {
        this.setState({
          error:`Something went wrong-${err}`,
          disabled: false
        });
      });
    }else{
      this.setState({
        disabled: false
      });
    }
  }

  

  render() {
    console.log('render', this.state)
    return (
      <div className="content">
        <Container fluid>
          <Row>
            <Col md={12}>
              {this.state.error &&
                <Alert bsStyle="danger">
                  <button type="button" aria-hidden="true" className="close">
                    &#x2715;
                  </button>
                  <span>{this.state.error}</span>
                </Alert>
              }
              <Card
                title="Edit Trengo Key"
                button={
                  <Link to={`/admin/meta`} className="btn btn-success pull-left card-back-button libi-admin-btn"> Back</Link>
                }
                content={
                  <form onSubmit={this.handleSubmit}>
                    <Row>
                      <div className="col-md-6">
                        <FormGroup>
                          <FormLabel>Key</FormLabel>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Key"
                            name="key"
                            value= {this.state.key}
                            onChange = {(event) => this.onChangeHandler(event)}
                            disabled={true}
                          />
                          <span className="help-block">{this.state.errors.key}</span>
                        </FormGroup>
                      </div>
                      <div className="col-md-6">
                        <FormGroup>
                          <FormLabel>Value</FormLabel>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Value"
                            name="value"
                            value= {this.state.value}
                            onChange ={(event)=>this.onChangeHandler(event)}
                          />
                          <span className="help-block">{this.state.errors.value}</span>
                        </FormGroup>
                      </div>
                    </Row>
                    <Button
                      className="btn-fill pull-right libi-admin-btn"
                      bsStyle="info" 
                      pullRight fill 
                      type="submit"
                      disabled={this.state.disabled}
                    >
                      {this.state.disabled ? 'Loading...' : 'Update'}
                    </Button>
                    <div className="clearfix" />
                  </form>
                }
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default EditTrengoKey;
